import React, { ReactNode } from "react";

import { Box } from "@mui/material";
import Typography from "@mui/material/Typography";

import { useAuth } from "../../contexts/AuthContext";
import { UserRole } from "../../services/api/AuthUser";

type AccessControlProps = {
  requiredRoles: UserRole[];
  fallback?: ReactNode;
  children: ReactNode;
};

export const UnauthorizedPage = (
  <Box
    display="flex"
    flexDirection="column"
    alignItems="center"
    justifyContent="center"
    minHeight="200px"
    textAlign="center"
  >
    <Typography variant="h2" component="h1" gutterBottom>
      🚫 Unauthorized
    </Typography>
    <Typography variant="h5">You do not have permission to access this page.</Typography>
  </Box>
);

const RoleBasedRender: React.FC<AccessControlProps> = ({ requiredRoles, fallback, children }) => {
  const { currentUser } = useAuth();
  if (!currentUser.role) return <>{fallback}</>;

  const hasAccess = requiredRoles.includes(currentUser.role);

  return hasAccess ? <>{children}</> : <>{fallback}</>;
};

export default RoleBasedRender;
